// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorFulfillmentDocuments = (client) => ({
    /**
     * `POST /vendor/fulfillment-documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateFulfillmentDocument
     * @source packages/medusa-plugin-fulfillment-documents/src/api/vendor/fulfillment-documents/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/fulfillment-documents", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/fulfillment-documents/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteFulfillmentDocument
     * @source packages/medusa-plugin-fulfillment-documents/src/api/vendor/fulfillment-documents/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/fulfillment-documents/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/fulfillment-documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListFulfillmentDocuments
     * @source packages/medusa-plugin-fulfillment-documents/src/api/vendor/fulfillment-documents/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/fulfillment-documents", { method: "GET", query, headers }),
    /**
     * `GET /vendor/fulfillment-documents/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetFulfillmentDocument
     * @source packages/medusa-plugin-fulfillment-documents/src/api/vendor/fulfillment-documents/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/fulfillment-documents/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/fulfillment-documents/:id/signed-url`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetFulfillmentDocumentSignedUrl
     * @source packages/medusa-plugin-fulfillment-documents/src/api/vendor/fulfillment-documents/[id]/signed-url/route.ts
     */
    retrieveSignedUrl: (id, query, headers) => client.fetch(buildPath("/vendor/fulfillment-documents/:id/signed-url", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=fulfillment-documents.js.map